import { render } from "./supportTable.vue?vue&type=template&id=1205773f"
import script from "./supportTable.vue?vue&type=script&lang=js"
export * from "./supportTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__